import { useEffect, useState } from "react";
import TableTerms from "./TableTerms";
import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CgSpinner } from "react-icons/cg";

const TermsData = [
  {
    id: 1,
    particulars: "Visa",
    remark: "Provided by Soundlines Administrative Co.",
  },
  {
    id: 2,
    particulars: "Air Tickets Joining",
    remark: "Borne by each recruited candidate ",
  },
  {
    id: 3,
    particulars: "Air Tickets Return",
    remark: "As per SAUDI labor Law /  Company Policy",
  },
  {
    id: 4,
    particulars: "Salary",
    remark: "As per the above requirement table",
  },
  {
    id: 5,
    particulars: "Food",
    remark: "As per the above requirement table",
  },
  {
    id: 6,
    particulars: "Accommodation / Transportation",
    remark: "Provided by the Company",
  },
  {
    id: 7,
    particulars: "Service Charges",
    remark: "Borne by each recruited candidate",
  },
  {
    id: 8,
    particulars: "Medical/Insurance &Iqama",
    remark:
      "Provided by  Soundlines Administrative Co. with no deduction from Candidates Salary",
  },
  {
    id: 9,
    particulars: "Working Hours",
    remark:
      "09 hours a day(including 1 hour break) /6 days a week + O.T. (if applicable)",
  },
  {
    id: 10,
    particulars: "Holiday",
    remark: "One day in a week",
  },
  {
    id: 11,
    particulars: "Other Benefits",
    remark: "As per Company policy & SAUDI labor law.",
  },
  {
    id: 12,
    particulars: "Mode of Recruitment",
    remark: "Client Interview",
  },
  {
    id: 13,
    particulars: "Delegate Expenses",
    remark: "Borne by the delegates ",
  },
  {
    id: 14,
    particulars: "Deployment Sector",
    remark: "Please confirm before issuance ",
  },
  {
    id: 15,
    particulars: "Contract Period",
    remark: "02 Years renewable ",
  },
  {
    id: 16,
    particulars: "Emigrate Registration",
    remark: "YES",
  },
];

export default function Terms({ setData }) {
  const [show, setShow] = useState(false);
  const [allTerms, setAllTerms] = useState(TermsData);

  useEffect(() => {
    const copyTerms = [...allTerms];
    let newTerms = [];
    copyTerms.forEach((item) => {
      newTerms.push({ particular: item?.particulars, remark: item?.remark });
    });
    setData((prev) => ({
      ...prev,
      terms_and_conditions: newTerms,
    }));
  }, [allTerms]);

  const addTerm = () => {
    const newTerm = {
      id: Math.floor(Math.random() * 1000),
      particulars: "",
      remark: "",
    };

    setAllTerms((prev) => [...prev, newTerm]);
  };

  //Final Data

  console.log(allTerms, "all terms");

  return (
    <>
      <div className="flex flex-wrap gap-4 ">
        <div className="max-w-sm min-w-max  w-full flex gap-3 items-center h-fit">
          <button
            className="p-1 rounded-md ring-1 ring-slate-200"
            onClick={() => setShow((p) => !p)}
            type="button"
          >
            {show ? (
              <RiArrowDownSLine size={"1.4rem"} />
            ) : (
              <RiArrowRightSLine size={"1.4rem"} />
            )}
          </button>
          <div>
            <h2 className="font-semibold">Terms and condition</h2>
            <p>Provide Terms and condition.</p>
          </div>
        </div>
        <div
          className={`w-full overflow-hidden  px-4 rounded-md transition-all  ${
            show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
          }`}
        >
          <div className="flex justify-between p-3">
            <button
              type="button"
              className="bg-red text-white p-2 rounded-md mt-2 ml-2"
              onClick={addTerm}
            >
              + Add Another
            </button>
            {/* commented the select option for the template as per client request */}
            {/* <div className="flex gap-3 items-center">
                <p>Template : </p>
                <select
                    value={selectedTemplate?.name}
                    onChange={handleTemplateChange}
                    className="select select-sm select-bordered"
                  >
                    <option value="" hidden>Select Template</option>
                    {templates?.map((template) => (
                      <option key={template.name} value={template.name}>
                        {template.name}
                      </option>
                    ))}
                  </select>
              </div> */}
          </div>
          <TableTerms allTerms={allTerms} setAllTerms={setAllTerms} />
        </div>
      </div>
    </>
  );
}
